import { EmergencyStatusEnum } from '@src/features/order/entities';

type ResetFn = () => void;

/** Emergency REST commands that dismiss an active Go Here marker (Pause keeps it visible). */
const EMERGENCY_COMMANDS_THAT_CLEAR_GO_HERE = new Set<string>([
  EmergencyStatusEnum.CONTINUE,
  EmergencyStatusEnum.LAND,
  EmergencyStatusEnum.RETURN,
]);

export function shouldClearGoHereOnEmergencyCommand(command: string): boolean {
  return EMERGENCY_COMMANDS_THAT_CLEAR_GO_HERE.has(command);
}

const bySerial = new Map<string, ResetFn>();

/** Latest registered reset (active drones page / mission map). */
let latestReset: ResetFn | null = null;

export function registerGoHereReset(serial: string, reset: ResetFn): void {
  bySerial.set(serial, reset);
  latestReset = reset;
}

export function unregisterGoHereReset(serial: string): void {
  bySerial.delete(serial);
  if (bySerial.size === 0) {
    latestReset = null;
  }
}

/** Clears Go Here marker + route for the given serial, or the last active handler. */
export function clearActiveGoHere(serial?: string | null): void {
  if (serial) {
    const fn = bySerial.get(serial);
    if (fn) {
      fn();
      return;
    }
  }
  latestReset?.();
}
